const DOCUMENT_FLAG = {
  Suspended: { value: 1 },
  Expired: { value: 2 },
  AwaitingOriginalCopy: { value: 3 }
};

type DOCUMENT_FLAG = typeof DOCUMENT_FLAG;

export default DOCUMENT_FLAG;
